export default __webpack_public_path__ + "static/media/@juuupiress.2aa2001a.jpg";